import { render, staticRenderFns } from "./shipment-form.vue?vue&type=template&id=6c7b59dc&scoped=true"
import script from "./shipment-form.vue?vue&type=script&lang=js"
export * from "./shipment-form.vue?vue&type=script&lang=js"
import style0 from "./shipment-form.vue?vue&type=style&index=0&id=6c7b59dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7b59dc",
  null
  
)

export default component.exports